export default [
  {
    url: "/dashboard",
    name: "Dashboard",
    slug: "Dashboard",
    icon: "HomeIcon",
    i18n: "sidebar.label.dashboard",
  },
  {
    url: "/customers",
    name: "Customers",
    slug: "Customer",
    icon: "UserIcon",
    i18n: "sidebar.label.customers",
  },
  {
    url: "/order_management",
    name: "Order Management",
    icon: "ShoppingCartIcon",
    slug: "app-user-view",
    i18n: "sidebar.label.order_management",
  },
  {
    url: "/inventory/goodsreceipt",
    name: "Inventory",
    slug: "Inventory",
    icon: "GiftIcon",
    i18n: "sidebar.label.inventory",
    submenu: [
      {
        url: "/inventory/goodsreceipt",
        name: "Goods Receipt",
        slug: "goods-receipt",
        icon: "PackageIcon",
        i18n: "inventory.label.header",
      },
      {
        url: "/inventory/stockupload",
        name: "Stock Upload",
        slug: "stock-upload",
        icon: "UploadCloudIcon",
        i18n: "stockUpload.label.header",
      },
      {
        url: "/inventory/stocktransfer",
        name: "Stock Transfer",
        slug: "stock-transfer",
        icon: "RepeatIcon",
        i18n: "stockTransfer.label.header",
      },
      {
        url: "/inventory/stocktransfer",
        name: "No Generators",
        slug: "No Generators",
        icon: "HashIcon",
        i18n: "sidebar.label.no_generator",
        submenu: [
          {
            url: "/inventory/voucher-pins",
            name: "Voucher Pin",
            icon: "PercentIcon",
            slug: "voucher-pins",
            i18n: "setup.label.VoucherPin",
          },
          {
            url: "/inventory/vendor-management",
            name: "Vendor Management",
            icon: "TruckIcon",
            slug: "vendor-management",
            i18n: "setup.label.VendorManagement",
          },
          {
            url: "/inventory/ip-management",
            name: "IP Management",
            icon: "GlobeIcon",
            slug: "ip-management",
            i18n: "setup.label.IpManagement",
          },
          {
            url: "/inventory/sim-numbers",
            name: "Sim Numbers",
            icon: "UserIcon",
            slug: "sim-numbers",
            i18n: "setup.label.SIMNumber",
          },
        ],
      },
    ],
  },
  {
    url: null,
    name: "Tickets",
    icon: "TagIcon",
    slug: "ticketing",
    i18n: "sidebar.label.tickets",
    submenu: [
      {
        url: "/customer_tickets",
        name: "Customer Tickets",
        icon: "TagIcon",
        slug: "customer-tickets",
        i18n: "ticket.label.CustomerTickets",
      },
      {
        url: "/entity_tickets",
        name: "Business Entity Tickets",
        icon: "TagIcon",
        slug: "entity-tickets",
        i18n: "tickets.label.customer.entity",
      },
      {
        url: "/group-ticketing",
        name: "Group Ticketing",
        icon: "TagIcon",
        slug: "group-ticketing",
        i18n: "setup.label.group_ticketing",
      },
    ],
  },
  {
    url: "/businessEntity",
    name: "Business Entity",
    slug: "Business Entity",
    icon: "UserPlusIcon",
    i18n: "sidebar.label.business_entity",
  },
  {
    url: "/leads_history",
    name: "Leads",
    icon: "UserCheckIcon",
    slug: "leads",
    i18n: "sidebar.label.leads",
  },
  {
    url: null,
    name: "System",
    icon: "SettingsIcon",
    i18n: "sidebar.label.system",
    submenu: [
      {
        url: "/rbac",
        name: "RBAC",
        icon: "UserIcon",
        slug: "app-user-view",
        i18n: "RBAC",
        submenu: [
          {
            url: "/userView",
            name: "Users",
            icon: "UserIcon",
            slug: "users",
            i18n: "system.label.users",
          },
          {
            url: "/manageRoles",
            name: "Roles",
            icon: "StarIcon",
            slug: "roles",
            i18n: "system.label.roles",
          },
        ],
      },
      {
        url: "/currencyconfig",
        name: "Currency Master",
        icon: "DollarSignIcon",
        slug: "app-user-view",
        i18n: "reports.label.currencyMaster",
        submenu: [
          {
            url: "/currencyconfig",
            name: "Currency Non Currency",
            icon: "DollarSignIcon",
            slug: "currencyconfig",
            i18n: "system.label.currency_noncurrency",
          },
          {
            url: "/currencyExchangeList",
            name: "Currency Exchange",
            icon: "ListIcon",
            slug: "currencyExchangeList",
            i18n: "system.label.currencyExchange",
          },
        ],
      },
      {
        url: "/config",
        name: "Configurations",
        icon: "SettingsIcon",
        slug: "app-user-view",
        i18n: "reports.label.configurations",
        submenu: [
          {
            url: "/globalConfig",
            name: "Global Configuration",
            icon: "GlobeIcon",
            slug: "global-config",
            i18n: "system.label.GlobalConfiguration",
          },
          {
            url: "/paymentConfig",
            name: "Payment Gateway Configuration",
            icon: "CreditCardIcon",
            slug: "app-user-view",
            i18n: "system.label.PaymentGatewayConfiguration",
          },
          {
            url: "/systemHooks",
            name: "Hooks",
            icon: "SettingsIcon",
            slug: "app-user-view",
            i18n: "system.label.Hooks",
          },
          {
            url: "/systemEnum",
            name: "ENUM",
            icon: "SettingsIcon",
            slug: "app-user-view",
            i18n: "ENUM",
          },
          {
            url: "/provisioningDevice",
            name: "Provisioning Device",
            icon: "TabletIcon",
            slug: "app-user-view",
            i18n: "system.label.ProvisioningDevice",
          },
          {
            url: "/provisionCommand",
            name: "Provision Command",
            icon: "CommandIcon",
            slug: "app-user-view",
            i18n: "system.label.ProvisionCommand",
          },
          {
            url: "/provisioningAction",
            name: "Provisioning Actions",
            icon: "SlidersIcon",
            slug: "app-user-view",
            i18n: "system.label.ProvisioningActions",
          },
          {
            url: "/networkSystem",
            name: "Network System",
            icon: "WifiIcon",
            slug: "app-user-view",
            i18n: "system.label.NetworkSystem",
          },
          {
            url: "/manageCodesList",
            name: "Manage Codes",
            icon: "CodeIcon",
            slug: "app-user-view",
            i18n: "system.label.ManageCodes",
          },
        ],
      },
      {
        url: "/makerchecker",
        name: "More",
        icon: "SettingsIcon",
        slug: "app-user-view",
        i18n: "More",
        submenu: [
          {
            url: "/makerchecker",
            name: "Maker Checker",
            icon: "BriefcaseIcon",
            slug: "maker-checker",
            i18n: "sidebar.label.maker_checker",
          },
          {
            url: "/reportsList",
            name: "Manage Reports",
            icon: "BarChartIcon",
            slug: "app-user-view",
            i18n: "reports.label.manageReports",
          },
          {
            url: "/message-template",
            name: "Message Template",
            icon: "MessageSquareIcon",
            slug: "app-user-view",
            i18n: "setup.label.MessageTemplate",
          },
          {
            url: "/question-answer-set",
            name: "Q & A Set",
            icon: "BookOpenIcon",
            slug: "question-answer-set",
            i18n: "setup.label.questionAnswerSet",
          },
          {
            url: "/shift-management",
            name: "Shift Management",
            icon: "CalendarIcon",
            slug: "shift-management",
            i18n: "setup.label.ShiftManagement",
          },
          {
            url: "/user-shift-mapping",
            name: "User Working Shift",
            icon: "CalendarIcon",
            slug: "user-shift-mapping",
            i18n: "setup.label.UserWorkingShift",
          },
          {
            url: "/holiday-management",
            name: "Holiday Management",
            icon: "SunIcon",
            slug: "holiday-management",
            i18n: "system.label.HolidayManagement",
          },
          {
            url: "/calendar",
            name: "Calendar",
            icon: "CalendarIcon",
            slug: "calender",
            i18n: "system.label.Calendar",
          },
        ],
      },
    ],
  },
  {
    url: null,
    name: "Setup",
    icon: "LayersIcon",
    i18n: "sidebar.label.setup",
    submenu: [
      {
        url: "/setup/collection-profile",
        name: "Collection Profile",
        icon: "BellIcon",
        slug: "app-user-view",
        i18n: "setup.label.collection_profile",
      },
      {
        url: "/setup/automation-master",
        name: "Automation Master",
        icon: "ToolIcon",
        slug: "app-user-view",
        i18n: "setup.label.automation_master",
      },
      {
        url: "/setup/general",
        name: "General",
        icon: "HomeIcon",
        slug: "setup-general",
        i18n: "sidebar.label.general",
        submenu: [
          {
            url: "/setup/address-master",
            name: "Address Master",
            icon: "MapPinIcon",
            slug: "address-master",
            i18n: "setup.label.AddressMaster",
          },
          {
            url: "/setup/property-definition",
            name: "Property Definition",
            icon: "BookIcon",
            slug: "property-definition",
            i18n: "setup.label.PropertyDefinition",
          },
          {
            url: "/setup/closed-user-group",
            name: "Closed User Group",
            icon: "XSquareIcon",
            slug: "closed-user-group",
            i18n: "setup.label.ClosedUserGroup",
          },
        ],
      },
      {
        url: "/inventory/stocktransfer",
        name: "Assets",
        slug: "assets",
        icon: "ClipboardIcon",
        i18n: "sidebar.label.assets",
        submenu: [
          {
            url: "/inventory/supplier",
            name: "Supplier",
            icon: "UserIcon",
            slug: "supplier",
            i18n: "setup.label.Supplier",
          },
          {
            url: "/inventory/item-model",
            name: "Item Model",
            icon: "CheckCircleIcon",
            slug: "item-model",
            i18n: "setup.label.ItemModel",
          },
          {
            url: "/inventory/items",
            name: "Items",
            icon: "BoxIcon",
            slug: "items",
            i18n: "setup.label.Items",
          },
        ],
      },
      {
        url: null,
        name: "Plan Management",
        icon: "ServerIcon",
        slug: "plan-management",
        i18n: "setup.label.PlanManagement",
        submenu: [
          {
            url: "/setup/plan-pricing",
            name: "Plan",
            icon: "ListIcon",
            slug: "app-user-view",
            i18n: "setup.label.Plan",
          },
          {
            url: "/setup/discount",
            name: "Discount",
            icon: "Minimize2Icon",
            slug: "discount",
            i18n: "setup.label.Discount",
          },
          {
            url: "/setup/discount-promotion",
            name: "Promotion",
            icon: "AlignLeftIcon",
            slug: "discount-promotion",
            i18n: "setup.label.Promotion",
          },
          {
            url: "/setup/plan-validation-rules",
            name: "Plan Validation Rules",
            icon: "FileTextIcon",
            slug: "app-user-view",
            i18n: "sidebar.label.plan_validation_rules",
          },
          {
            url: "/setup/zone-setup",
            name: "Zone Setup",
            icon: "MapPinIcon",
            slug: "app-user-view",
            i18n: "setup.label.ZoneSetup",
            submenu: [
              {
                url: "/setup/zone-setup/number",
                name: "Number Zone",
                icon: "HashIcon",
                slug: "price-region",
                i18n: "setup.label.NumberZone",
              },
              {
                url: "/setup/zone-setup/apn",
                name: "APN Zone",
                icon: "MousePointerIcon",
                slug: "setup-services",
                i18n: "setup.label.APNZone",
              },
              {
                url: "/setup/zone-setup/operator",
                name: "Operator Zone",
                icon: "CpuIcon",
                slug: "setup-products",
                i18n: "setup.label.OperatorZone",
              },
              {
                url: "/setup/zone-setup/ic",
                name: "IC Zone",
                icon: "CpuIcon",
                slug: "sales-cataloge-mapping",
                i18n: "setup.label.ICZone",
              },
            ],
          },
          {
            url: "/setup/usage-rating",
            name: "Usage Rating",
            icon: "StarIcon",
            slug: "app-user-view",
            i18n: "setup.label.UsageRating",
            submenu: [
              {
                url: "/setup/usage-rating/template",
                name: "Template Definition",
                icon: "BookIcon",
                slug: "template",
                i18n: "setup.label.TemplateDefinition",
              },

              {
                url: "/setup/usage-rating/uom",
                name: "UOM",
                icon: "BoxIcon",
                slug: "setup-uom",
                i18n: "setup.label.UOM(Unit Of measurement)",
              },
              {
                url: "/setup/usage-rating/rum",
                name: "RUM",
                icon: "BarChart2Icon",
                slug: "setup-rum",
                i18n: "setup.label.RUM(RatableUsageMetric)",
              },

              {
                url: "/setup/usage-rating/time",
                name: "Time Period",
                icon: "ClockIcon",
                slug: "time-period",
                i18n: "setup.label.TimePeriod",
              },
              {
                url: "/setup/usage-rating/rateplan",
                name: "Usage Rate Plan",
                icon: "TagIcon",
                slug: "sales-rate-plan",
                i18n: "setup.label.UsageRatePlan",
              },
            ],
          },
        ],
      },
      {
        url: "/setup/ticketing",
        name: "Ticketing",
        icon: "TagIcon",
        slug: "ticketing",
        i18n: "sidebar.label.ticketing",
        submenu: [
          {
            url: "/setup/group-ticketing",
            name: "Group Ticketing",
            icon: "TagIcon",
            slug: "setup-group-ticketing",
            i18n: "setup.label.group_ticketing",
          },
          {
            url: "/setup/team",
            name: "Team",
            icon: "UsersIcon",
            slug: "setup-team",
            i18n: "setup.label.Team",
          },
          {
            url: "/setup/team-user",
            name: "Team User",
            icon: "UserIcon",
            slug: "setup-team-user",
            i18n: "setup.label.TeamUser",
          },
          {
            url: "/setup/leave-management",
            name: "Leave Management",
            icon: "UserCheckIcon",
            slug: "leave-management",
            i18n: "setup.label.LeaveManagement",
          },
          {
            url: "/setup/team-mapping",
            name: "Team Mapping",
            icon: "Minimize2Icon",
            slug: "team-mapping",
            i18n: "setup.label.TeamMapping",
          },
          {
            url: "/setup/priority-mapping",
            name: "Sub Category",
            icon: "AlignLeftIcon",
            slug: "priority-mapping",
            i18n: "setup.label.SubCategory",
          },
          {
            url: "/setup/customer-feedback",
            name: "Customer Feedback",
            icon: "MessageCircleIcon",
            slug: "customer-feedback",
            i18n: "setup.label.CustomerFeedback",
          },
        ],
      },
      {
        url: "/setup/subscription",
        name: "Subscription Master",
        icon: "DollarSignIcon",
        slug: "app-user-view",
        i18n: "sidebar.label.subscription_master",
        submenu: [
          {
            url: "/setup/charge-code",
            name: "Charge Code",
            icon: "UsersIcon",
            slug: "charge-code",
            i18n: "setup.label.ChargeCode",
          },
          {
            url: "/setup/contract-period",
            name: "Contract Period",
            icon: "UserIcon",
            slug: "setup-contract-period",
            i18n: "setup.label.ContractPeriod",
          },
          {
            url: "/setup/fee-master",
            name: "Fee Master",
            icon: "Minimize2Icon",
            slug: "fee-master",
            i18n: "setup.label.FeeMaster",
          },
          {
            url: "/setup/tax",
            name: "Tax Master",
            icon: "AlignLeftIcon",
            slug: "tax",
            i18n: "setup.label.TaxMaster",
          },
          {
            url: "/setup/price-region",
            name: "Price Region",
            icon: "GlobeIcon",
            slug: "price-region",
            i18n: "setup.label.PriceRegion",
          },
          {
            url: "/setup/service-products/services",
            name: "Services",
            icon: "CastIcon",
            slug: "setup-services",
            i18n: "setup.label.Services",
          },
          {
            url: "/setup/service-products/products",
            name: "Products",
            icon: "TabletIcon",
            slug: "setup-products",
            i18n: "setup.label.Products",
          },
          {
            url: "/setup/cataloge-mapping/sales",
            name: "Sales Catalogue",
            icon: "DollarSignIcon",
            slug: "sales-cataloge-mapping",
            i18n: "setup.label.SalseCatalogue",
          },
          // {
          //   url: "/setup/cataloge-mapping/user",
          //   name: "User Catalogue",
          //   icon: "UsersIcon",
          //   slug: "user-cataloge-mapping",
          //   i18n: "setup.label.UserCatalogue",
          // },
          {
            url: "/setup/broadcaster-channel",
            name: "Sub Products",
            icon: "AlignLeftIcon",
            slug: "broadcaster-channel",
            i18n: "sidebar.label.sub_products",
          },
          {
            url: "/setup/media-pricing",
            name: "Media Details",
            icon: "InfoIcon",
            slug: "app-user-view",
            i18n: "setup.label.MediaDetails",
            submenu: [
              {
                url: "/setup/media-pricing/details",
                name: "Details Of Media",
                icon: "VideoIcon",
                slug: "media-details",
                i18n: "setup.label.DetailsOfMedia",
              },

              {
                url: "/setup/media-pricing/event",
                name: "Details Of Event",
                icon: "ZapIcon",
                slug: "event",
                i18n: "setup.label.DetailsOfEvent",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    url: null,
    name: "Accounting",
    icon: "UserIcon",
    i18n: "sidebar.label.accounting",
    submenu: [
      {
        url: "/chart_of_accounts",
        name: "Chart Of Accounts",
        icon: "BarChartIcon",
        slug: "app-user-view",
        i18n: "accounting.label.chartofaccounts",
      },
      {
        url: "/accounting_rules",
        name: "Accounting Rules",
        icon: "FileTextIcon",
        slug: "app-user-view",
        i18n: "accounting.label.accountingrules",
      },
      {
        url: "/closing_entries",
        name: "Closing Entries",
        icon: "FolderIcon",
        slug: "app-user-view",
        i18n: "accounting.label.closingentries",
      },
      {
        url: "/frequent_postings",
        name: "Frequent Postings",
        icon: "RefreshCwIcon",
        slug: "app-user-view",
        i18n: "accounting.label.frequentpostings",
      },
      {
        url: "/add_journal_entries",
        name: "Add Journal Entries",
        icon: "PlusIcon",
        slug: "app-user-view",
        i18n: "accounting.label.addjournalentries",
      },
      {
        url: "/financial_activity_mappings",
        name: "Financial Activity Mappings",
        icon: "GitMergeIcon",
        slug: "app-user-view",
        i18n: "accounting.label.financialactivitymapping",
      },
      {
        url: "/search_journal_entries",
        name: "Search Journal Entries",
        icon: "SearchIcon",
        slug: "app-user-view",
        i18n: "sidebar.label.search_journal_entries",
      },
      {
        url: "/migrate_opening_balances",
        name: "Migrate Opening Balances",
        icon: "DollarSignIcon",
        slug: "app-user-view",
        i18n: "sidebar.label.migrate_opening_balances",
      },
    ],
  },
  {
    url: "/bill-management",
    name: "Billing Management",
    slug: "Billing Management",
    icon: "ClipboardIcon",
    i18n: "billManagement.label.BillingManagement",
  },
  {
    url: "/reports",
    name: "Reports",
    icon: "BarChart2Icon",
    slug: "Reports",
    i18n: "sidebar.label.reports",
  },
  {
    url: null,
    name: "Admin",
    icon: "UsersIcon",
    i18n: "sidebar.label.admin",
    submenu: [
      {
        url: "/bulk_uploads",
        name: "Bulk Uploads",
        icon: "DownloadIcon",
        slug: "app-user-view",
        i18n: "sidebar.label.bulk_uploads",
      },
      {
        url: "/maker-checker-action",
        name: "Maker Check Action",
        icon: "CheckIcon",
        slug: "app-user-checker",
        i18n: "sidebar.label.makerCheckerAction",
      },
      {
        url: "",
        name: "Command Center",
        icon: "CommandIcon",
        slug: "app-user-list",
        i18n: "sidebar.label.command_center",
      },
      {
        url: "/eventaction",
        name: "Hooks (Event Actions)",
        icon: "BriefcaseIcon",
        slug: "app-user-view",
        i18n: "sidebar.label.hooks",
      },

      {
        url: "/online_payments",
        name: "Payment Transactions",
        icon: "CreditCardIcon",
        slug: "app-user-list",
        i18n: "sidebar.label.payment_transactions",
      },

      {
        url: "/message_log",
        name: "Message Log",
        icon: "MessageSquareIcon",
        slug: "app-user-list",
        i18n: "admin.label.MessageLog",
      },

      {
        url: "/scheduler_jobs",
        name: "Scheduler Jobs",
        icon: "GlobeIcon",
        slug: "app-user-view",
        i18n: "sidebar.label.scheduler_job",
      },
    ],
  },
];
